export default {
  title: 'Detalles del precio',
  subtotal: 'Subtotal',
  method_fee: 'Gastos de envío',
  tip: 'Propina',
  service_fee: 'Procesamiento en línea',
  payment_method_upcharge_fee: 'Comisión PayPal',
  discount: 'Descuento',
  taxes: 'Impuestos',
  total: 'Total',
};
